(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buyzar-marketplace"] && !Shopify.designMode) return;
  try {
    (()=>{const r=document.getElementById('bz-market-{{ section.id }}');if(!r)return;const t=r.querySelector('[data-bz-track]'),s=[...r.querySelectorAll('.bz-hero__slide')],d=r.querySelector('[data-bz-dots]');let i=0;if(s.length){s.forEach((_,n)=>{const b=document.createElement('button');b.type='button';b.onclick=()=>go(n);d.appendChild(b)});const go=n=>{i=(n+s.length)%s.length;t.style.transform='translateX(-'+i*100+'%)';[...d.children].forEach((b,x)=>b.setAttribute('aria-current',x===i?'true':'false'))};r.querySelector('[data-bz-prev]').onclick=()=>go(i-1);r.querySelector('[data-bz-next]').onclick=()=>go(i+1);go(0);setInterval(()=>go(i+1),5000)}const e=r.querySelector('[data-bz-countdown]');if(e){const z=new Date(e.dataset.end).getTime();const f=()=>{const x=Math.max(0,z-Date.now());e.textContent=x?String(Math.floor(x/36e5)).padStart(2,'0')+' : '+String(Math.floor(x%36e5/6e4)).padStart(2,'0')+' : '+String(Math.floor(x%6e4/1e3)).padStart(2,'0'):'SALE ENDED'};f();setInterval(f,1000)}const q=r.querySelector('.bz-search input'),b=r.querySelector('[data-bz-suggestions]');let tm;q?.addEventListener('input',()=>{clearTimeout(tm);const v=q.value.trim();if(v.length<2){b.hidden=true;return}tm=setTimeout(async()=>{try{const x=await fetch('/search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product,collection&resources[limit]=6').then(a=>a.json());const p=x.resources?.results?.products||[],c=x.resources?.results?.collections||[];b.innerHTML=[...c.map(a=>'<a href="'+a.url+'">▦ '+a.title+'</a>'),...p.map(a=>'<a href="'+a.url+'">'+a.title+'</a>')].join('')||'<a href="/search?q='+encodeURIComponent(v)+'">Search for '+v+'</a>';b.hidden=false}catch(_){b.hidden=true}},220)});r.querySelector('[data-bz-voice]')?.addEventListener('click',()=>{const S=window.SpeechRecognition||window.webkitSpeechRecognition;if(!S)return;const x=new S();x.lang='en-IN';x.onresult=a=>{q.value=a.results[0][0].transcript;q.dispatchEvent(new Event('input'))};x.start()});r.querySelector('[data-bz-focus-search]')?.addEventListener('click',()=>q?.scrollIntoView({behavior:'smooth',block:'center'}))})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
